export default "//yastatic.net/s3/distribution/pythia/frontend/_/0db8dc611b08318a1c4785543870ad21.jpeg";